import React from 'react';
import { Carousel } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './Carousel.module.scss';
import { PrimaryButton } from 'components/buttons';
import 'animate.css';
import { Link } from 'react-router';

interface CarouselComponentProps {
  items: {
    image: string;
    text: string;
  }[];
}

const CarouselComponent: React.FC<CarouselComponentProps> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <Carousel autoplay>
      {items.map((item, index) => (
        <div key={index} className={styles['carousel-slide']}>
          <img src={item.image} alt={`Slide ${index + 1}`} className={styles['carousel-image']} />
          <div className={styles['carousel-content']}>
            <h2 className='animate__animated animate__fadeInDown'>{item.text}</h2>
            <div className={styles['carousel-buttons']}>
              {/* Left Button - White Default */}
              <PrimaryButton className={styles['btn-secondary-custom']}>
                <a href='https://app.carbondigitalmarket.com/'> {t('caruselButton1')}</a>
                <img src='/images/arrow.png' alt='' className={styles['arrow-icon']} />
              </PrimaryButton>

              {/* Right Button - Green Default */}
              <PrimaryButton className={styles['btn-primary-custom']}>
                <Link to='/impact'>{t('caruselButton2')}</Link>
                <img src='/images/arrow.png' alt='' className={styles['arrow-icon']} />
              </PrimaryButton>
            </div>
          </div>
        </div>
      ))}
    </Carousel>
  );
};

export default CarouselComponent;
